import React from 'react';
import { Menu, Moon, Sun } from 'lucide-react';
import crownLogo from '../../public/logo.png';
import { useAppDispatch, useAppSelector } from '../store';
import { toggleSidebar, toggleDarkMode } from '../store/uiSlice';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';
import NotificationsDropdown from './NotificationsDropdown';
import { useAuthUser } from '../Hooks/useAuth';

const Navbar = () => {
  const dispatch = useAppDispatch();
  const collapsed = useAppSelector((s) => s.ui.sidebarCollapsed);
  const darkMode = useAppSelector((s) => s.ui.darkMode);
  const { t, i18n } = useTranslation();
  const { user } = useAuthUser();
  
  // التحقق من صلاحية production
  const canViewNotifications = user?.role === 'production';

  return (
    <header className="bg-[var(--sidebar)] border-b border-[var(--sidebar-border)] h-14 flex items-center px-4">
      <div className="flex items-center gap-3 text-[var(--foreground)]">
        <div className="mx-auto h-6 w-10 flex items-center justify-center mb-3">
          <img 
            src={crownLogo} 
            alt="Crown Logo" 
            className="h-6 w-10"
          />
        </div>

        <h1
          className={`text-sm font-bold transition-all duration-300 overflow-hidden text-[var(--sidebar-accent-foreground)] whitespace-nowrap ${
          collapsed ? 'opacity-0 w-0' : 'opacity-100 w-auto'}`}
        >
          {t('appName')}
        </h1>

        <button
          onClick={() => dispatch(toggleSidebar())}
          className={`ml-2 p-2 rounded-lg hover:bg-white/10 text-[var(--sidebar-accent-foreground)] transition-colors duration-200 ${
            !collapsed ? 'mr-4' : ''
          }`}
          title={collapsed ? t('toggleSidebarOpen') : t('toggleSidebarClose')}
          aria-label="toggle sidebar"
        >
          <Menu className="w-[1em] h-[1em]" />
        </button>
      </div>
      <div
        className={`${
          i18n.language && i18n.language.startsWith('ar') ? 'mr-auto' : 'ml-auto'
        } flex items-center gap-2`}
      >
        {/* إشعارات السحوبات - تظهر فقط لمستخدمي production */}
        {/* {canViewNotifications && <NotificationsDropdown />} */}
        
        <button
          onClick={() => dispatch(toggleDarkMode())}
          className="p-2 rounded-lg hover:bg-white/10 text-[var(--sidebar-accent-foreground)] transition-colors duration-200"
          title={darkMode ? t('toggleDarkEnableLight') : t('toggleDarkEnableDark')}
          aria-label="تبديل الوضع المظلم"
        >
          {darkMode ? (
            <Sun className="w-5 h-5" />
          ) : (
            <Moon className="w-5 h-5" />
          )}
        </button>
        <LanguageSwitcher />
      </div>
    </header>
  );
};

export default Navbar;